module.exports = __webpack_public_path__ + "fonts/Zp79v5K8.woff2";